import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24c47c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("状态")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("添加工种")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("状态")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "工种管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "关键字",
          value: _ctx.searches.name,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onSearch,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          style: {"margin-top":"10px"},
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: false,
          "row-key": (record)=>record.id
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#108ee9"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "设置该工种状态?",
                    "ok-text": "启用",
                    "cancel-text": "禁用",
                    onConfirm: ($event: any) => (_ctx.onDel(record,1)),
                    onCancel: ($event: any) => (_ctx.onDel(record,0))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"]),
                  (record.pid==0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        onClick: ($event: any) => (_ctx.addSon(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "row-key"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _ctx.handleOk,
      width: "20%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: _ctx.name,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
          placeholder: "请输入"
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible2,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible2) = $event)),
      title: "查看工种",
      width: "40%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          style: {"margin-top":"0px"},
          dataSource: _ctx.sonData,
          columns: _ctx.columns2,
          bordered: "",
          pagination: false
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status == 1)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#108ee9"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "设置该工种状态?",
                    "ok-text": "启用",
                    "cancel-text": "禁用",
                    onConfirm: ($event: any) => (_ctx.onDel(record,1)),
                    onCancel: ($event: any) => (_ctx.onDel(record,0))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm", "onCancel"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}